var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_data"},[_c('div',{staticClass:"no_data_main"},[_c('img',{attrs:{"src":require("_images/cos/filebg.png")}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }